import { Cell, flexRender } from '@tanstack/react-table';
import { cell as cellVariant } from './variants';

type BodyCellProps<TData, TValue = unknown> = {
  cell: Cell<TData, TValue>;
};

export function BodyCell<TData>(props: BodyCellProps<TData>) {
  const { cell } = props;

  return (
    <div key={cell.id} className={cellVariant()} role="cell">
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </div>
  );
}
